/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable max-len */
import { useRef, forwardRef, useImperativeHandle, useEffect, useState } from 'react';

import useStyles from './style';
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import {
  dataPreference,
  getFromLS,
  publicImagePath,
  publicImgMajorTest,
  publicSvgPath,
} from '@orientaction/utils';
import dateFormat from 'dateformat';
import SliderScore from '@orientaction/components/SliderScore';
import { getUserById } from '../../../../services/user.service';
import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import { modalStaticBlockElement as proModalStaticBlockElement } from '../VariableDetailsModal/constant';

export interface ResultatPDFHandle {
  handleDownload: () => Promise<void>;
}

const ResultatPDF = forwardRef<ResultatPDFHandle, { myResult: any; idResult: number }>(
  ({ myResult, idResult }, ref) => {
    const classes = useStyles({});
    const contentRef = useRef<HTMLDivElement>(null);
    const { perso, users_permissions_user } = myResult;
    const token = getFromLS('userToken') || '';
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [date, setDate] = useState<string>('');

    useEffect(() => {
      const getUser = () => {
        setLoading(true);
        if (token && users_permissions_user) {
          getUserById({ token, userId: users_permissions_user })
            .then((res: any) => {
              setUser(res?.data ?? {});
              return 'ok';
            })
            .then(() => {
              setLoading(false);
            });
        }
      };
      getUser();
    }, [users_permissions_user, token]);

    useEffect(() => {
      setDate(myResult?.listHistory.find((item: any) => item.id === idResult)?.createdAt);
    }, [myResult, idResult]);

    const handleDownload = async () => {
      if (!contentRef.current) {
        return;
      }

      const { default: html2pdf } = await import('html2pdf.js');

      const options = {
        margin: [0, 0, 0, 0], // Pas de marge externe, la mise en page est gérée par le padding interne
        filename: `Résultat Needs® Pro, test des 7 besoins professionnels - ${user?.firstname || ''} ${user?.lastname || ''}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#FFF', // Fond blanc comme le conteneur PDF
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Format A4 en pixels à ~150 DPI : 1240px × 1754px (210mm × 297mm)
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: '.page-break-before',
          after: '.page-break-after',
        },
      } as any;

      html2pdf().set(options).from(contentRef.current).save();
    };

    useImperativeHandle(ref, () => ({
      handleDownload,
    }));

    const lang: string = useSelector(appLanguage);

    const getImg = (key: string): string => {
      switch (key) {
        case 'physiological_pro':
          return '/images/need/en_physiologique.png';

        case 'security_pro':
          return '/images/need/en_security.png';

        case 'horizontal_belonging_pro':
          return '/images/need/en_appartenance.png';

        case 'vertical_belonging_pro':
          return '/images/need/en_appartenance_V.png';

        case 'accomplishment_pro':
          return '/images/need/en_Accomplissement.png';

        case 'self_realization_pro':
          return '/images/need/en_realisation_soi.png';

        case 'spirituality_pro':
          return '/images/need/en_spiritualite.png';

        case 'eternity_pro':
          return '/images/need/en_eternity.png';

        case 'vertical_belonging_perso':
          return '/images/need/eN_Appartenance_V.png';

        case 'physiological_perso':
          return '/images/need/Physiologique.png';

        case 'security_perso':
          return '/images/need/en_security.png';

        case 'horizontal_belonging_perso':
          return '/images/need/en_appartenance.png';

        case 'accomplishment_perso':
          return '/images/need/en_Accomplissement.png';

        case 'self_realization_perso':
          return '/images/need/en_realisation_soi.png';

        case 'spirituality_perso':
          return '/images/need/en_spiritualite.png';

        case 'eternity_perso':
          return '/images/need/en_eternity.png';

        default:
          return '';
      }
    };

    return (
      <>
        {!loading && (
          <div className={classes.wrapper}>
            <div ref={contentRef} className={classes.page}>
              <div className={classes.header}>
                <Typography variant="h2" className={classes.titleHeader} style={{ margin: 0 }}>
                  Needs® Pro, test des 7 besoins professionnels
                </Typography>
              </div>
              <div className="page-break-after" style={{ padding: '80px 80px 0px 80px' }}>
                <div className={classes.imgBanner}>
                  <img
                    src={`${publicImgMajorTest}/illustration_banniere_needs_pro.png`}
                    alt="couverture intro"
                  />
                </div>
                <div className={classes.info}>
                  <div className={classes.infoContent}>
                    Nom du test :{' '}
                    <span>Needs® Pro, test des 7 besoins professionnels</span>
                  </div>
                  <div className={classes.infoContent}>
                    Bénéficiaire :{' '}
                    <span>
                      {user?.firstname} {user?.lastname}
                    </span>
                  </div>
                  <div className={classes.infoContent}>
                    Date de passation :{' '}
                    <span>{date && dateFormat(new Date(date), 'dd/mm/yyyy')}</span>
                  </div>
                  <div className={classes.infoContent}>
                    Consultant :{' '}
                    <span>
                      {user?.upper_hierarchy?.firstname} {user?.upper_hierarchy?.lastname}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ padding: '40px 80px 80px 80px' }}>
                <div className={`${classes.section} page-break-after`}>
                  <h2 className={`${classes.heading} ${classes.h1}`}>Pyramide des besoins</h2>
                  <div className={classes.sliderScore} style={{ marginTop: 80 }}>
                    <div className={classes.imgPyramidContainer}>
                      <img
                        src={
                          lang !== 'FR'
                            ? getImg(myResult?.favorite?.key)
                            : myResult?.favorite?.imgPyramid
                        }
                        className={classes.imgPyramid}
                        alt="Pyramide"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: 70,
                      fontSize: 24,
                      fontWeight: 700,
                      fontFamily: 'Poppins',
                      lineHeight: 1.4,
                    }}>
                    Votre besoin principal
                  </div>
                  <h2 className={`${classes.heading} ${classes.h4}`} style={{ marginTop: 30 }}>
                    Dans votre vie professionnelle
                  </h2>
                  <p className={classes.paragraph}>
                    Voici votre besoin principal dans votre vie professionnelle. La satisfaction de
                    vos besoins est à la source de votre bien-être et de votre motivation. Il est
                    important que votre métier, vos conditions de travail et de rémunération, ainsi
                    que vos relations professionnelles contribuent pleinement à satisfaire ce
                    besoin.
                  </p>
                  <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 20 }}>
                    {myResult?.favorite?.label}
                  </h2>

                </div>
                <div className={`${classes.section} page-break-after`} style={{ paddingTop: 20 }}>
                  <h2 className={`${classes.heading} ${classes.h3}`}>
                    Application dans votre vie pro
                  </h2>
                  <p className={classes.paragraph}>
                    Si vous ne vous sentez pas pleinement satisfait(e) dans votre vie
                    professionnelle, c’est sans doute parce que certains de vos besoins ne sont pas
                    satisfaits. Dans le domaine professionnel, cela peut être d’avoir une
                    rémunération que vous jugez insuffisante, d’avoir des relations de mauvaise
                    qualité avec vos collègues ou encore de ne pas avoir un poste suffisamment
                    stimulant par rapport à vos attentes.
                  </p>
                  <p className={classes.paragraph}>
                    Tous ces éléments risquent d’entraîner de la démotivation. Au contraire, si vos
                    besoins sont satisfaits, alors vous vous sentirez pleinement motivé(e) par votre
                    travail. Voilà pourquoi il faut être à l’écoute de vos besoins et être capable
                    de les expliciter à votre manager. Cela lui permettra de tenter d’y répondre.
                    Vous vous sentirez compris(e) et vous aurez le sentiment de progresser…
                  </p>
                </div>
                <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
                  <div className={classes.score}>
                    {myResult.treeMax[0].label}
                    <span>{myResult.treeMax[0].score}</span>
                    <span>/125</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    Votre besoin pour être heureux(se)
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html:
                        myResult?.treeMax[0] &&
                        proModalStaticBlockElement[myResult?.treeMax[0]?.key]?.toBeHappy?.content,
                    }}
                  />
                  <div className={classes.imgWhiteBanner}>
                    <img
                      src={
                        lang !== 'FR'
                          ? getImg(myResult?.treeMax[0]?.key)
                          : `${publicImagePath}/need/${
                              proModalStaticBlockElement[myResult?.treeMax[0]?.key]?.img
                            }`
                      }
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à privilégier :
                  </h2>
                  {proModalStaticBlockElement[myResult?.treeMax[0]?.key]?.environmentToPrivilege
                    .type === 'paragraph' ? (
                    <p className={classes.paragraph} style={{ fontWeight: 400 }}>
                      {
                        proModalStaticBlockElement[myResult?.treeMax[0]?.key]
                          ?.environmentToPrivilege.content
                      }
                    </p>
                  ) : (
                    <ul className={classes.listUl}>
                      {proModalStaticBlockElement[
                        myResult?.treeMax[0]?.key
                      ]?.environmentToPrivilege.content?.map((elem: any, index: number) => (
                        <li key={elem} className={classes.listLi}>
                          <Typography
                            variant="body2"
                            component="p"
                            dangerouslySetInnerHTML={{
                              // eslint-disable-next-line react/destructuring-assignment
                              __html: elem,
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à éviter :
                  </h2>
                  <p className={classes.paragraph} style={{ fontWeight: 400 }}>
                    {
                      proModalStaticBlockElement[myResult?.treeMax[0]?.key]?.environmentToAvoid
                        .content
                    }
                  </p>
                </div>

                <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
                  <div className={classes.score}>
                    {myResult.treeMax[1].label}
                    <span>{myResult.treeMax[1].score}</span>
                    <span>/125</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    Votre besoin pour être heureux(se)
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html:
                        myResult?.treeMax[1] &&
                        proModalStaticBlockElement[myResult?.treeMax[1]?.key]?.toBeHappy?.content,
                    }}
                  />
                  <div className={classes.imgWhiteBanner}>
                    <img
                      src={
                        lang !== 'FR'
                          ? getImg(myResult?.treeMax[1]?.key)
                          : `${publicImagePath}/need/${
                              proModalStaticBlockElement[myResult?.treeMax[1]?.key]?.img
                            }`
                      }
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à privilégier :
                  </h2>
                  {proModalStaticBlockElement[myResult?.treeMax[1]?.key]?.environmentToPrivilege
                    .type === 'paragraph' ? (
                    <p className={classes.paragraph} style={{ fontWeight: 400 }}>
                      {
                        proModalStaticBlockElement[myResult?.treeMax[1]?.key]
                          ?.environmentToPrivilege.content
                      }
                    </p>
                  ) : (
                    <ul className={classes.listUl}>
                      {proModalStaticBlockElement[
                        myResult?.treeMax[1]?.key
                      ]?.environmentToPrivilege.content?.map((elem: any, index: number) => (
                        <li key={elem} className={classes.listLi}>
                          <Typography
                            variant="body2"
                            component="p"
                            dangerouslySetInnerHTML={{
                              // eslint-disable-next-line react/destructuring-assignment
                              __html: elem,
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à éviter :
                  </h2>
                  <p className={classes.paragraph} style={{ fontWeight: 400 }}>
                    {
                      proModalStaticBlockElement[myResult?.treeMax[1]?.key]?.environmentToAvoid
                        .content
                    }
                  </p>
                </div>

                <div className={`${classes.section}`} style={{ paddingTop: 80 }}>
                  <div className={classes.score}>
                    {myResult.treeMax[2].label}
                    <span>{myResult.treeMax[2].score}</span>
                    <span>/125</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    Votre besoin pour être heureux(se)
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html:
                        myResult?.treeMax[2] &&
                        proModalStaticBlockElement[myResult?.treeMax[2]?.key]?.toBeHappy?.content,
                    }}
                  />
                  <div className={classes.imgWhiteBanner}>
                    <img
                      src={
                        lang !== 'FR'
                          ? getImg(myResult?.treeMax[2]?.key)
                          : `${publicImagePath}/need/${
                              proModalStaticBlockElement[myResult?.treeMax[2]?.key]?.img
                            }`
                      }
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à privilégier :
                  </h2>
                  {proModalStaticBlockElement[myResult?.treeMax[2]?.key]?.environmentToPrivilege
                    .type === 'paragraph' ? (
                    <p className={classes.paragraph} style={{ fontWeight: 400 }}>
                      {
                        proModalStaticBlockElement[myResult?.treeMax[2]?.key]
                          ?.environmentToPrivilege.content
                      }
                    </p>
                  ) : (
                    <ul className={classes.listUl}>
                      {proModalStaticBlockElement[
                        myResult?.treeMax[2]?.key
                      ]?.environmentToPrivilege.content?.map((elem: any, index: number) => (
                        <li key={elem} className={classes.listLi}>
                          <Typography
                            variant="body2"
                            component="p"
                            dangerouslySetInnerHTML={{
                              // eslint-disable-next-line react/destructuring-assignment
                              __html: elem,
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                  <h2 className={`${classes.heading} ${classes.h6}`}>
                    Les environnements professionnels à éviter :
                  </h2>
                  <p className={classes.paragraph} style={{ fontWeight: 400, marginBottom: 0 }}>
                    {
                      proModalStaticBlockElement[myResult?.treeMax[2]?.key]?.environmentToAvoid
                        .content
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
);

ResultatPDF.displayName = 'ResultatPDF';

export default ResultatPDF;
